import { buildFieldContext } from '../../utils/pageSetup';

/**
 * Page setup export options for a stored document: its page_setup (local `pageSetup` or the row's
 * `page_setup`; null = defaults) and the live-field values for its header and footer (title =
 * document name, customer and project from its project, date = created date).
 *
 * @param {object} document - Local document (or generated_documents row).
 * @param {object} [context] - Values the caller knows.
 * @param {string} [context.projectName] - Project name.
 * @param {string} [context.customerName] - Customer name.
 * @returns {{pageSetup: object|null, fieldContext: object}} Options for the Word / PDF / HTML exports.
 */
export function documentExportOptions(document, { projectName = '', customerName = '' } = {}) {
  const pageSetup = document?.pageSetup !== undefined ? document.pageSetup : document?.page_setup;
  const customer = customerName || (document?.customerName && document.customerName !== 'Unknown customer' ? document.customerName : '');
  return {
    pageSetup: pageSetup ?? null,
    fieldContext: buildFieldContext({
      title: document?.name || '',
      customer,
      project: projectName || document?.projectName || '',
      createdAt: document?.createdAt || document?.created_at || null,
    }),
  };
}

/**
 * The customer name of the project a document belongs to.
 * @param {object|null|undefined} state - App state (projects, customers).
 * @param {object} document - Local document.
 * @returns {string} Customer name ('' when unknown).
 */
export function customerNameForDocument(state, document) {
  if (!state || !document) return '';
  const projectId = document.projectId || document.project_id;
  const project = (state.projects || []).find((p) => (projectId ? p.id === projectId
    : (p.generatedDocuments || []).some((d) => d.id === document.id)));
  if (!project) return '';
  const customer = project.customer || (state.customers || []).find((c) => c.id === project.customer_id);
  return customer?.name || '';
}
